import { Paper, Stack, Typography } from '@mui/material';

import type { DashboardStat } from './types';

export type StatTileProps = {
  stat: DashboardStat;
};

export const StatTile = ({ stat }: StatTileProps) => (
  <Paper variant="outlined" sx={{ p: 2.5, flexGrow: 1 }}>
    <Stack sx={{ gap: 0.5 }}>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ fontWeight: 600, letterSpacing: 0.5, lineHeight: 1.4 }}
      >
        {stat.label}
      </Typography>
      <Typography variant="h4" component="p" sx={{ fontWeight: 700, lineHeight: 1.1 }}>
        {stat.value}
      </Typography>
      {stat.caption && (
        <Typography variant="caption" sx={{ color: 'success.main', fontWeight: 600 }}>
          {stat.caption}
        </Typography>
      )}
    </Stack>
  </Paper>
);
